// DEMO UTILITIES - portrait ratio helpers for DemoContext, DemoWrapper and DemoRatioApplier.

export type PortraitRatio = '16:9' | '18.5:9' | 'freestyle';

export const getRatioStyles = (ratio: PortraitRatio) => {
    switch (ratio) {
        case '16:9':
            return {
                maxWidth: '28rem', // 448px - typical 16:9 portrait width
                aspectRatio: '9/16',
                containerClass: 'demo-ratio-16-9'
            };
        case '18.5:9':
            return {
                maxWidth: '26rem', // 416px - typical 18.5:9 portrait width
                aspectRatio: '9/18.5',
                containerClass: 'demo-ratio-18-5-9'
            };
        case 'freestyle':
        default:
            return {
                maxWidth: 'none',
                aspectRatio: 'auto',
                containerClass: 'demo-ratio-freestyle'
            };
    }
};

export const applyRatioStyles = (ratio: PortraitRatio) => {
    const styles = getRatioStyles(ratio);

    if (ratio === 'freestyle') {
        return {
            maxWidth: 'none',
            width: '100%'
        };
    }

    return {
        maxWidth: styles.maxWidth,
        aspectRatio: styles.aspectRatio,
        width: '100%',
        margin: '0 auto'
    };
};
